import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { inject, Component, EventEmitter, Input, Output } from '@angular/core';
import { ICart } from '@models/payment.model';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UtmWalletHundredComponent } from '../utm-wallet-hundred/utm-wallet-hundred.component';
import { DonateBtnComponent } from 'src/app/core/donate-btn/donate-btn.component';

@Component({
  selector: 'app-wallets',
  templateUrl: './wallets.component.html',
  styleUrls: ['./wallets.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    UtmWalletHundredComponent,
    DonateBtnComponent
  ]
})
export class WalletsComponent {

  private util = inject(UtilService);
  public paymentUtil = inject(PaymentUtilService);
  public vars = inject(VariablesService);

  @Input() option;
  @Input() topWallets;
  @Input() cartDetails: ICart;
  @Input() isOrderLoading;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();
  selectedWallet;
  walletForm: FormGroup;
  walletName: FormControl;

  ngOnInit() {
    this.walletForm = new FormGroup({
      walletName: this.walletName = new FormControl('', [Validators.required])
    });
  }
  /**Get the keys of bank list object */
  getWalletNames(data) {
    return data ? this.util.sortArray(Object.keys(data)) : null;
  }
  selectWallet(name) {
    this.selectedWallet = name;
    this.walletName.setValue(name);
  }
  /**On click event of top banks */
  submitWallet() {
    if (this.walletForm.valid) {
      const data = {
        'mode': 'WALLET',
        'mode_value': this.walletName.value,
      };
      this.dataEmit.emit(data);
    } else {
      this.util.checkValidForm(this.walletForm);
    }
  }
}
